import {
  getQueryStringParams,
  deleteQueryStringParam,
} from "../../shared/utils";

export const triageSquadManagerStore = {
  activeTab: "your-teams",
  teamLeadSquadIds: [],
  inProgressSnapshotSquadIdsByCurrentUser: [],
  squadsInProgressByOtherUsers: {},
  confirmationModalOpen: false,
  pendingSnapshotSquadId: null,
  clearConfirmationModalOpen: false,
  pendingClearSnapshotSquadId: null,
  pendingClearIsOwnTeam: false,
  clearResponsesUrl: null,

  setInitialState({
    currentUserIncompleteSquads,
    hasMultipleTeams,
    snapshotSquadId,
    snapshotSquads,
    allIncompleteSquads = {},
    teamLeadSquadIds = [],
    inProgressSnapshotSquadIdsByCurrentUser = [],
    squadsInProgressByOtherUsers = {},
    clearResponsesUrl = null,
  }) {
    const openAutomatically = getQueryStringParams().get("triage") == "1";

    this.currentUserIncompleteSquads = currentUserIncompleteSquads;
    this.hasMultipleTeams = hasMultipleTeams;
    this.snapshotSquadId = snapshotSquadId;
    this.snapshotSquads = snapshotSquads;
    this.allIncompleteSquads = allIncompleteSquads;
    this.teamLeadSquadIds = teamLeadSquadIds;
    this.inProgressSnapshotSquadIdsByCurrentUser =
      inProgressSnapshotSquadIdsByCurrentUser;
    this.squadsInProgressByOtherUsers = squadsInProgressByOtherUsers;
    // Default to 'all-teams' if user is not a team lead for any teams
    this.activeTab =
      teamLeadSquadIds.length === 0
        ? "all-teams"
        : this.activeTab || "your-teams";
    this.confirmationModalOpen = false;
    this.pendingSnapshotSquadId = null;
    this.clearConfirmationModalOpen = false;
    this.pendingClearSnapshotSquadId = null;
    this.pendingClearIsOwnTeam = false;
    this.clearResponsesUrl = clearResponsesUrl;
    this.needsPanelRefresh = false;

    if (openAutomatically) {
      if (this.hasMultipleTeams) {
        this.multiTeamModalOpen = true;
      } else {
        this.squadViewModalOpen = true;
      }
    }
  },
  numIncomplete() {
    // Count incomplete squads the user leads, excluding those being triaged by others
    const teamLeadCount = Object.keys(this.currentUserIncompleteSquads).filter(
      (squadId) => !this.squadsInProgressByOtherUsers[Number(squadId)],
    ).length;

    // Count squads user is triaging on teams they don't lead
    const inProgressOnOtherTeams =
      this.inProgressSnapshotSquadIdsByCurrentUser.filter(
        (squadId) => !this.teamLeadSquadIds.includes(Number(squadId)),
      ).length;

    return teamLeadCount + inProgressOnOtherTeams;
  },
  openTriageModal() {
    this.hasMultipleTeams
      ? (this.multiTeamModalOpen = true)
      : (this.squadViewModalOpen = true);
  },
  clearOpenAutomaticallyParam() {
    deleteQueryStringParam("triage");
  },
  // Open squad view, with confirmation if user is not a team lead
  // Skip confirmation if user already has in-progress triage (they're returning to finish)
  openSquadView(snapshotSquadId) {
    const isTeamLead = this.teamLeadSquadIds.includes(snapshotSquadId);
    const hasInProgressTriage =
      this.inProgressSnapshotSquadIdsByCurrentUser.includes(snapshotSquadId);
    const isCompleted =
      !this.currentUserIncompleteSquads[snapshotSquadId] &&
      !this.allIncompleteSquads[snapshotSquadId];

    if (isTeamLead || hasInProgressTriage || isCompleted) {
      this.snapshotSquadId = snapshotSquadId;
      this.squadViewModalOpen = true;
    } else {
      // Show confirmation modal for non-team-leads starting fresh triage
      this.pendingSnapshotSquadId = snapshotSquadId;
      this.confirmationModalOpen = true;
    }
  },
  confirmOpenSquadView() {
    this.snapshotSquadId = this.pendingSnapshotSquadId;
    this.pendingSnapshotSquadId = null;
    this.confirmationModalOpen = false;
    this.squadViewModalOpen = true;
  },
  cancelConfirmation() {
    this.pendingSnapshotSquadId = null;
    this.confirmationModalOpen = false;
  },
  openClearConfirmation(snapshotSquadId) {
    this.pendingClearSnapshotSquadId = snapshotSquadId;
    this.pendingClearIsOwnTeam =
      this.teamLeadSquadIds.includes(snapshotSquadId);
    this.clearConfirmationModalOpen = true;
  },
  cancelClearConfirmation() {
    this.pendingClearSnapshotSquadId = null;
    this.clearConfirmationModalOpen = false;
  },
  async confirmClearAndRestart() {
    const snapshotSquadId = this.pendingClearSnapshotSquadId;
    this.clearConfirmationModalOpen = false;
    this.pendingClearSnapshotSquadId = null;
    this.pendingClearIsOwnTeam = false;
    try {
      const response = await fetch(this.clearResponsesUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            ?.content,
        },
        body: JSON.stringify({ squad_id: snapshotSquadId }),
      });

      if (!response.ok) throw new Error("Failed to clear responses");

      delete this.squadsInProgressByOtherUsers[snapshotSquadId];
      this.allIncompleteSquads[snapshotSquadId] = true;
      this.snapshotSquadId = snapshotSquadId;
      this.squadViewModalOpen = true;
      this.needsPanelRefresh = true;
    } catch (error) {
      console.error("Failed to clear triage responses:", error);
    }
  },
};
